import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/**
 * One round trip, every brand's asset count at once - same Lambda as
 * createAsset/listAssets (request_type: "studio/create_asset"), routed via
 * request_sub_type. Returns {brandId: count}.
 */
export async function countAssetsByBrand(appConfig, brandIds, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "count_assets_by_brand",
    client_id: appConfig.clientId,
    brand_ids: brandIds,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  if (!response?.data?.counts) {
    throw new Error(response?.data?.error || "Couldn't load asset counts");
  }
  return response.data.counts;
}